import AirbnbSvg from '@/../img/airbnb-custom.svg';
import BookingSvg from '@/../img/booking-custom.svg';
import OthersSvg from '@/../img/generic-property-custom.svg';
import HomeawaySvg from '@/../img/homeaway-custom.svg';
import FlipkeySvg from '@/../img/other-platforms-custom.svg';
import VrboSvg from '@/../img/vrbo-custom.svg';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { cssVars } from '@/app/styles';
import { onlinePlatforms } from '@/constants';
import { Path, Svg } from './donut-styles';

// These are icons that will be displayed in the center of the donut.
// They are specific to this component
const onlinePlatformLogos = {
  [onlinePlatforms.AIRBNB]: AirbnbSvg,
  [onlinePlatforms.VRBO]: VrboSvg,
  [onlinePlatforms.BOOKING]: BookingSvg,
  [onlinePlatforms.OTHERS]: OthersSvg,
  [onlinePlatforms.FLIP_KEY]: FlipkeySvg,
  [onlinePlatforms.HOME_AWAY]: HomeawaySvg,
};

/**
 * Opinionated donut chart component that renders an icon in the center.
 * It is called opinionated because it sets its own dimensions, colors, and only displays
 * predetermined icons in its center
 *
 * The plan is to generalize this component only if there is need
 *
 * @param {object} props
 * @param {Number} percentage percentage proportion to which the donut will be filled
 * @param {string} logoName e.g.: 'airbnb', 'brbo'. logo names defined in src/constants
 */
export function OpinionatedDonut({ logoName, percentage }) {
  let Logo = onlinePlatformLogos[logoName];

  if (!Logo) {
    Logo = onlinePlatformLogos[onlinePlatforms.OTHERS];
  }

  return (
    <Svg viewBox="0 0 36 36">
      <circle
        cx="15"
        cy="15"
        r="16"
        stroke="#eaedf4"
        fill="none"
        transform="translate(3, 3)"
        strokeWidth="3"
      />
      <Path
        stroke={cssVars.color[logoName]}
        strokeDasharray={`${percentage}, 100`}
        d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
      />
      <svg width="90px" height="90px" viewBox="-12 -12 120 120">
        <Logo />
      </svg>
    </Svg>
  );
}

OpinionatedDonut.propTypes = {
  percentage: PropTypes.number.isRequired,
  logoName: PropTypes.string.isRequired,
};

export const Donut = memo(OpinionatedDonut);
